const milestones = [
  ["Jordan", "Mechanical Engineering"],
  ["Software", "Development Diploma"],
  ["Hungary", "Vehicle Engineering"],
  ["Research", "Vehicle Research Center"],
  ["Competition", "RoboRacer · IEEE IV 2025"],
  ["Academia", "Teaching Assistant"],
  ["Today", "Automotive R&D Engineer"],
];

export default function Journey() {
  return (
    <section id="journey" className="journey-section">
      <div className="container" data-aos="fade-up">
        <div className="section-title section-title-left">
          <span className="section-index">02 — Journey</span>
          <h2>From mechanical systems to autonomous machines</h2>
        </div>
        <div className="journey-track">
          {milestones.map(([label, detail], index) => (
            <div className="journey-step" key={detail}>
              <span className="journey-number">{String(index + 1).padStart(2, "0")}</span>
              <div><strong>{label}</strong><p>{detail}</p></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
